; (function (jQuery) {

	const TippyTooltips = {

		init() {
			jQuery(document).ready(() => {
				this.bindTooltips();
			});
		},

		bindTooltips() {
			if (typeof window.tippy !== 'function') {
				return;
			}

			jQuery('.tippy-tooltip').each((_, tooltipWrapper) => {
				this.createTooltip(tooltipWrapper);
			});
		},

		createTooltip(tooltipWrapper) {
			const contentEl = tooltipWrapper.querySelector('.tippy-tooltip-content');
			const triggerEl = tooltipWrapper.querySelector('.tippy-tooltip-icon');

			if (!contentEl || !triggerEl) {
				return;
			}

			const content = contentEl.innerHTML.trim();
			if (!content) {
				return;
			}

			triggerEl.setAttribute('tabindex', '0');

			window.tippy(triggerEl, {
				allowHTML: true,
				arrow: true,
				content: content,
				maxWidth: 320,
				placement: 'top',
				trigger: 'mouseenter focus click'
			});
		}

	};

	if (document.querySelector('.tippy-tooltip')) {
		TippyTooltips.init();
	}

})(jQuery);
